<template>
  <div>
    <menubar :permission="permission"/>
    <div class="container">
      <div class="title-btn d-flex justify-content-between align-items-center">
        <div id="title" class="d-flex justify-content-start">
          <img src="/img/05_slash.svg" />
          
          <div v-if="!readonly">
            <p class="h1">用語集編集</p>
          </div>
          <div v-else>
            <p class="h1">用語集詳細</p>
          </div>
        </div>

        <!-- ################################################################ -->
        <div v-if="!readonly">
          <modal ref="childimportModal">
            <template v-slot:activator="{ openModal }">
              <button class="btn btn-purple btn-import" @click="openModal">
                インポート
              </button>
            </template>

            <template v-slot:modalTitle> 用語集のインポート </template>
            <template v-slot:modal-content="{ closeModal }">

              <div class="sub-content">
                <p class="h6"><b>インポートするファイルを選択</b></p>
                <div class="component">
                  <label class="d-flex justfy-content-center">
                    <input type=file class="upload" ref=file @input="this.glossaryFile = $event.target.files[0]">
                    <span class="file-name d-flex align-items-center" v-show="import_file_name!=''">{{import_file_name}}</span>
                  </label>
                </div>
              </div>
              <div class="modal-btn d-flex justify-content-evenly">
                <button class="btn btn-purple" @click="importModal()">インポート</button>
                <button class="btn btn-red" @click="closeModal()">キャンセル</button>
              </div>

            </template>
          </modal>
        </div>
        <!-- ################################################################ -->
      </div>


      <div class="edit-table-head">

        <div class="gls_info_txts">
          編集ファイル名：<br>
          <p class="h2"> 
            {{ glossaryInfo.name }} 
          <span v-if="readonly && glossaryInfo.editing_user != undefined" class="gls_info_txts__editing_by">
            ({{glossaryInfo.editing_user.name}} が編集中)
          </span>
          </p>
        </div>

        <div class="gls_row_cntr" title="登録単語数"> 
          <span class="gls_row_cntr__num">{{glossaryContents.length}}</span>
        </div>

      </div>


      <table class="edit-table-main component_table" border="1" cellpadding="5">
        <tbody>
          <tr>
            <th class="th--no">No</th>
            <th class="th--phrase">{{glossaryInfo.src_language.name}}</th>
            <th class="th--phrase">{{glossaryInfo.trg_language.name}}</th>
            <th class="th--remarks">備考</th>
            <th v-if="!readonly" class="th--del">削除</th>
          </tr>

          <tr v-for="(item, index) in glossaryContents" :key="index" v-bind:class="[{'tr--readonly': readonly}]">
            <td class="tb_no text-center">{{ index+1 }}</td>
            <td v-bind:class="[{'td--phrase--editable': !readonly}]">
              <textarea class="phrase-textarea" rows="1"
                v-if="!readonly" v-model="item.src"
                @input="resizeTextareaHeight('src'+index.toString())" :ref="'src' + index"
              ></textarea>
              <div v-else>{{item.src}}</div>
            </td>
            <td v-bind:class="[{'td--phrase--editable': !readonly}]">
              <textarea 
                class="phrase-textarea" rows="1" 
                v-if="!readonly" v-model="item.trg" 
                @input="resizeTextareaHeight('trg'+index.toString())" :ref="'trg' + index"
              ></textarea>
              <div v-else>{{item.trg}}</div>
            </td>
            <td v-bind:class="[{'td--phrase--remarks': !readonly}]">
              <textarea 
                class="phrase-textarea" rows="1"
                v-if="!readonly" v-model="item.remark"
                @input="resizeTextareaHeight('remarks'+index.toString())" :ref="'remarks' + index"
              ></textarea>
              <div v-else>{{item.remark}}</div>
            </td>
            <td v-if="!readonly" class="delete text-center">
              <input type="checkbox" :id="'index'+index" :value="index" v-model="index_delete" />
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!readonly" class="replace-addrow-delete">
        <button class="btn btn-purple btn-size" @click="add()">
          <img src="/img/025_plus_icon.svg" />
          行を追加
        </button>

        <modal ref="childdeleteModal">

          <template v-slot:activator="{ openModal }">
            <button class="btn btn-red btn-delete" @click="checkconfirmModal()">
              削除
            </button>
          </template>

          <template v-slot:modalTitle> 行を追加 </template>

          <template v-slot:modal-content="{ closeModal }">
            <p>以下を本当に削除しますか？</p>

            <table class="component_table delete-table" border="1">
              <tbody>
                <tr>
                  <th class="tb_del_src text-center">英語</th>
                  <th class="tb_del_trg text-center">日本語</th>
                  <th class="tb_del_remark text-center">備考</th>
                </tr>
                <tr v-for="index in index_delete" :key="index">
                  <td class="tb_del_src">{{ glossaryContents[index].src }}</td>
                  <td class="tb_del_trg">{{ glossaryContents[index].trg }}</td>
                  <td class="tb_del_remark">{{ glossaryContents[index].remark }}</td>
                </tr>
              </tbody>
            </table>

            <div class="modal-btn d-flex justify-content-evenly">
              <button class="btn btn-purple" @click="del()">はい</button>
              <button class="btn btn-red" @click="closeModal()">いいえ</button>
            </div>
          </template>
        </modal>
      </div>

      <div v-if="!readonly" class="button_close_save">
        <button class="btn btn-purple btn-close inline-block " @click="closePage">閉じる</button>
        <button class="btn btn-purple btn-save inline-block" @click="updateGlossary()">保存</button>
      </div>


    </div>
    <footerComponent />
  </div>
</template>

<script>
import { computed, defineComponent } from "vue";
import menubar from "@/Pages/Common/menu_wo_inertia.vue";
import modal from "@/Pages/Components/modal.vue";
import footerComponent from "@/Pages/Components/footer.vue";

export default defineComponent({
  components: {
    menubar,
    modal,
    footerComponent,
  },
  props: {
    glossaryInfo: Object,
    glossaryContents: Array,
    additionalGlossaryContents: Array,
    permission:String,
    readonly:Boolean,
  },
  data() {
    return {
      index_delete: [],
    };
  },
  methods: {
    resizeTextareaHeight: function(ref){
      var elements = this.$refs[ref];
      elements[0].style.height = "auto";
      elements[0].style.height = (elements[0].scrollHeight)+"px";
    },

    // 削除のチェエクボックスにチェックが付いていたらモーダル実行
    checkconfirmModal: function () {
      if (this.index_delete.length != 0) {
        this.$refs.childdeleteModal.openModal();
      }
    },

    // 表の行追加
    add: function() {
      this.glossaryContents.push({
        src: String(""),
        trg: String(""),
        remark: String(""),
        delete_modal: false,
      })
    },
    // 表の行削除
    del: function() {
      for (const index_delete of this.index_delete) {
        this.glossaryContents.splice(index_delete, 1);
      }
      this.index_delete = [];
      this.$refs.childdeleteModal.closeModal();
    },
    importModal: function () {
      if (this.glossaryFile != null){
        let data = new FormData();
        data.append('glossaryFile', this.glossaryFile);

        axios.post(
          this.route('glossaries.import', this.glossaryInfo.id),
          data
        ).then((response) => {
          console.log(response);
          try{
            for (const row of response.data){
              this.glossaryContents.push(
                {
                  src: (typeof row.src === 'string' ? row.src : String('')),
                  trg: (typeof row.trg === 'string' ? row.trg : String('')),
                  remark: (typeof row.remark === 'string' ? row.remark : String('')),
                  delete_modal: false,
                }
              )
            };
            this.$refs.file.value = '';
            this.glossaryFile = null;
            this.$refs.childimportModal.closeModal();
          }catch(err){
            console.log(err);
            alert("用語集ファイルの読み込みに失敗しました。対応している文字コードは、 ASCII,JIS,UTF-8,EUC-JP,SJIS です。繰り返し失敗する場合はお問い合わせください。");
          }
        }).catch(function (error){
          alert(error.response.data.message);
        });

      }else{
        alert("ファイルが選択されていません。")
      }
    },
    updateGlossary: function () {
      let glossaryContents = [...JSON.parse(JSON.stringify(this.glossaryContents))];
      glossaryContents.forEach(e => {
        delete e.delete_modal;
      })
      this.$inertia.patch(
        this.route('glossaries.update', this.glossaryInfo.id), 
        {glossaryContents},
        {
          onSuccess: ()=> {
            alert("保存しました。");
          },
          onError:(e)=>{
            alert(e.error_message);
          }
        }
      );
    },
    discardEdit: function () {
      this.$inertia.patch(
        this.route('glossaries.update', this.glossaryInfo.id), 
        {discard:true},
        {}
      );
    },
    leaveEditPage: function(event){
      event.preventDefault();
      event.returnValue = '';
    },
    closePage: function(){
      this.discardEdit();
      window.close();
    },
  },
  mounted: function(){
    if (this.readonly==true){
      if (this.glossaryInfo.editing_user == undefined){
        alert('ゲストのため、閲覧モードで表示します。');
      }else{
        alert(this.glossaryInfo.editing_user.name+'が編集中です。閲覧モードで表示します。');
      }
    }else{
      window.addEventListener('beforeunload', this.leaveEditPage);
      window.addEventListener('onpopstate', this.leaveEditPage);
      window.addEventListener("unload", this.discardEdit);
    }
  },
	unmounted() {
    if (this.readonly==false){
      window.removeEventListener("beforeunload", this.leaveEditPage);
      window.removeEventListener('onpopstate', this.leaveEditPage);
    }
	},

});
</script>

<style lang="scss" scoped>
.container {
  #title {
    margin: 3rem 0;
    img {
      width: 3rem;
      height: 3rem;
    }
    p {
      color: #333333;
    }
  }
  .title-btn {
    margin: 3rem 0;
    #title {
      margin: 0;
      img {
        width: 3rem;
        height: 3rem;
      }
      p {
        color: #333333;
      }
    }
  }
  min-height: 80vh;
}



/* 画像関係 */
.img_return {
  width: 80%;
  padding: 0 0 3px 0;
}
.img_download {
  width: 60%;
  padding: 5px 5px;
}


//#[テーブル上ヘッダ：ファイル名、閲覧ステータス、行数カウンタ]#################//
.edit-table-head{
  display: flex;
  justify-content: space-between;
  align-items: center;  
}
.gls_info_txts{
  color: #666666;
}
.gls_info_txts__editing_by{
  font-size: 1.2rem;
}

.gls_row_cntr{
  align-items: center;
  text-align: end;
}
.gls_row_cntr__num{
  font-size: 1.5rem;
  font-weight: bold;
  background: #e7e7eb;
  text-align: center;

  display: inline-block;
  width: 3rem;
  // height:1rem;

  border-radius: 5px;
  color: gray;
  padding: 0 0.1rem 0 0.1rem;
}

//############################################################################//
.edit-table-main{
  width: 100%;
  table-layout: fixed;
  overflow-wrap: break-word;
  word-wrap: break-word;
  thead{
    text-align: center;
  }
  tbody{
    text-align: center;
    td {
      text-align: center;
      vertical-align: middle;
      padding: 1.0rem 1.0rem;
    }

  }
}
.th--phrase{ width:auto; text-align:left; }
.th--remarks{ width:auto; text-align:left; }
.th--no{ width: 3rem; text-align: center;}
.th--del{ width: 3rem; text-align: center;}

.tr--readonly > td{ background: #fafafa; }

.td--phrase--editable{padding: 0.5rem 0.3rem 0.25rem 0.3rem} //[TODO]? hard coding
.td--remarks--editable{padding: 0.5rem 0.3rem 0.25rem 0.3rem} //[TODO]? hard coding
.phrase-textarea{
  width: 100%;
  background-color:transparent;
  resize: none;
  overflow: hidden;
  border: none;
  outline: none;
}




/* モーダル関係 */
.modal-title {
  font-size: 15px;
  background-color: #a07abe;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  color: #ffffff;
  padding: 10px;
  display: flex;
  justify-content: space-between;
}
/* モーダルウィンドウ */
.modal-window {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  background-color: #fffbf9;
  z-index: 11;
}
.modal-wrapper {
  padding: 20px 20px 20px 20px;
}
.modal-title > span {
  font-weight: 100;
  cursor: pointer;
}
/* オーバーレイ */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(120, 120, 120, 0.8);
  width: 100%;
  height: 100%;
  z-index: 10;
}

.post-edit-title {
  font-weight: 900;
  margin: 1rem 0.2rem 1rem 0;
  color: #666666;
}
.btn-import {
  width: 9rem;
  height: 2.5rem;
}


.modal-section-button {
  padding-top: 10px;
  text-align: center;
}
.btn-modal {
  font-size: 13px;
  padding: 0px 0px 0px 0px;
  height: 20px;
  width: 80px;
  margin: 0px 5px;
}
.button-replace {
  display: flex;
  margin-bottom: 5px;
}

.btn-size {
  width: 9rem;
  height: 2.5rem;
  img {
    width: 1.2rem;
  }
}
.replace-addrow-delete {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.btn-delete {
  // float: right;
  // position: relative;
  // bottom: 40px;
  height: 2.5rem;
  width: 4.5rem;
}

.button_file {
  color: #666666;
  background: transparent;
  border: none;
  text-decoration: underline;
  font-weight: bold;
}
.input_width {
  width: 90%;
}
.input_remarks {
  width: 90%;
  height: calc(1.3em * 5);
  line-height: 1.3;
}

// .post-edit-table-main {
//   height: 3rem;
//   th {
//     padding: 0.5rem;
//   }
//   td {
//     padding: 0.5rem 0.5rem;
//   }
// }

/* 表の調整 */
.tb_no {
  width: 4%;
}
.tb_English,
.tb_Japanese {
  width: 30%;
}
.tb_remarks {
  width: 100%;
}
.tb_delete {
  width: 4%;
}

.tb_del_src{
  width: 20%;
}
.tb_del_trg{
  width: 20%;
}
.tb_del_remark{
  width: 60%;
}

.button_close_save {
  padding: 2rem 0 2rem 0;
  display: flex;
  justify-content: center;
}
.btn-close {
  height: 2rem;
  width: 5rem;
  border: solid;
  border-color: #a07abe;
  background: #fffbf9;
  color: #a07abe;
  margin: 0 2rem 0 0;
}
.btn-save {
  height: 2.7rem;
  width: 5.69rem;
  margin: 0 0 0 2rem;
}

// インポートモーダル内の調整
.sub-content {
  margin: 0 0 1rem 0;
}

// 削除モーダル内の調整
.delete-table {
  width: 100%;
  margin-bottom: 1rem;
}

// ファイル名の隣のNo数の箱の調整
.display-no {
  margin: 1.1rem 0;
}
</style>
